export default "__VITE_ASSET__6KhlaTLr__"